<template>
    <div id="item-template">
        <li>
            <div :class="{ 'bold': isFolder }" @click="toggle" @dblclick="makeFolder" >
                <span style="margin-left: 5px; display:inline-flex" v-if="isFolder">[{{ isOpenText }}]
                <img style="margin-left: 5px" :src="item.imageURL" />
                <label class="ehr-regular-label ehr-white-label">{{ item.name }}</label></span>
                <span style="margin-left: 5px; display:inline-flex" v-if="!isFolder">
                <img style="margin-left: 5px" :src="item.imageURL" />
                <a @click="link_Clicked(item)"><label class="ehr-regular-label ehr-white-label">{{ item.name }}</label></a>
                <a v-show="showDeleteButton" class="svg-button svg-red-fill-btn" title="DELETE?"
                style="margin-left: 10px" @click="delete_Click(item)" >
                <svg width="18px" height="18px">
                <use xlink:href="/App_Themes/default1/icons/sapphire-svg-sprites.svg#cancelFilledIcon" />
                </svg>
                </a>
                </span>
            </div>
            <ul v-show="isOpen" v-if="isFolder" >
                <tree-item
                class="item"
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
                @make-folder="makeFolder($event)"
                @delete-item="delete_Click($event)"
                @item-link-clicked="link_Clicked($event)"
                ></tree-item>
           </ul>
        </li>
    </div>
</template>

<script>
    export default {
        props: {
            item: Object
        },
        data: function () {
            return {
                isOpen: false
            }
        },
        computed: {
           isFolder: function () {
                return this.item.children && this.item.children.length;
            },
            isOpenText: function () {
                return this.isOpen ? '-' : '+';
            },
            showDeleteButton: function () {
                return this.item.showDeleteButton;
            },
        },
        methods: {
            toggle: function() {
                if (this.isFolder) {
                    this.isOpen = !this.isOpen;
                }
            },
            makeFolder: function () {
                if (!this.isFolder) {
                    this.$emit("make-folder", this.item);
                    this.isOpen = true;
                }
            },
            link_Clicked: function (item) {
                this.$emit("item-link-clicked", item);
            },
            delete_Click: function (item) {
                this.$emit("delete-item", item);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .item {
        cursor: pointer;
        font: normal 12px "Roboto", sans-serif;
    }
    .bold {
        font-weight: bold;
        color: lightgray;
    }

    #divGenericTreeviewList {
        overflow: auto; 
        text-align: left;  
        color: white;
    }

    #divGenericTreeviewList ul{margin-left:1em}
</style>
